import logo from "@/assets/affarsnatverket-logo-new.png";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { openCookieSettings } from "@/components/CookieConsent";

const Footer = () => {
  const { t } = useTranslation();



  return (
    <footer className="bg-secondary/30 text-primary py-12 px-4">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-12 gap-y-8 mb-8">
          {/* Logo & Description */}
          <div className="md:col-span-2 lg:col-span-1">
            <img src={logo} alt="Affärsnätverket" width="160" height="64" loading="lazy" className="h-12 w-auto mb-4" />
            <p className="text-primary/80 max-w-md">
              {t("footer.description")}
            </p>
          </div>

          {/* Affärsnätverket */}
          <nav aria-label="Affärsnätverket">
            <h3 className="font-semibold mb-4 text-base">Affärsnätverket</h3>
            <ul className="space-y-2">
              <li><Link to="/foretagsnatverk" className="text-primary/70 hover:text-accent transition-colors">Nätverksträffar online</Link></li>
              <li><Link to="/kalender" className="text-primary/70 hover:text-accent transition-colors">Kalender</Link></li>
              <li><Link to="/news" className="text-primary/70 hover:text-accent transition-colors">Nyheter</Link></li>
              <li><Link to="/testimonials" className="text-primary/70 hover:text-accent transition-colors">Recensioner</Link></li>
            </ul>
          </nav>

          {/* Övrigt */}
          <nav aria-label="Övrigt">
            <h3 className="font-semibold mb-4">Övrigt</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://www.nyfikenmodellen.se/redovisning"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary/70 hover:text-accent transition-colors"
                >
                  NYFIKENmodellen®
                </a>
              </li>
            </ul>
          </nav>

          {/* Om oss */}
          <nav aria-label="Om oss">
            <h3 className="font-semibold mb-4">Om oss</h3>
            <ul className="space-y-2">
              <li><Link to="/om-oss" className="text-primary/70 hover:text-accent transition-colors">Om oss</Link></li>
              <li><Link to="/integritetsskydd-cookies-och-gdpr" className="text-primary/70 hover:text-accent transition-colors">Integritetsskydd & GDPR</Link></li>
              <li>
                <button
                  type="button"
                  onClick={openCookieSettings}
                  className="text-primary/70 hover:text-accent transition-colors text-left"
                >
                  Cookieinställningar
                </button>
              </li>
            </ul>
          </nav>

        </div>

        <div className="border-t border-primary/20 pt-8 text-center text-primary/60">
          <p>&copy; {new Date().getFullYear()} Affärsnätverket. {t("footer.copyright")}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
